import React, { memo } from "react";

import { ScoreConfig } from "types/PatientRegion";
import { icons } from "constants/icons";
import { RegionInfoItem } from "./RegionInfoItem";

type Props = {
  title: string;
  totalExams: number;
  completedSurveys: number;
};
export const SurveyBlock = memo(
  ({ title, totalExams, completedSurveys }: Props) => {
    return (
      <div className="flex flex-col">
        <div className="flex space-x-2 items-center mb-20">
          <img src={icons.patientShoulder} alt="status" />
          <div className="flex flex-col">
            <p className="flex items-baseline space-x-1  text-grayDark">
              <strong className="text-[28px] text-black leading-6">
                {title}
              </strong>
            </p>
          </div>
        </div>

        <div className="mb-5">
          <RegionInfoItem title="Total Exams">
            <div className="flex space-x-1 items-baseline">
              <strong className="text-xl">{totalExams || 0}</strong>
            </div>
          </RegionInfoItem>
        </div>

        <RegionInfoItem title="Outcome Scores">
          <div className="flex space-x-1 items-baseline">
            <strong className="text-xl">{completedSurveys || 0}</strong>
          </div>
        </RegionInfoItem>
      </div>
    );
  }
);
